<template>
  <CrudForm
    :title="title"
    :labelSubmit="labelSubmit"
    :storeName="storeName"
    :submit="submit"
    :status="status"
    :labelCancel="labelCancel"
    :parentStoreName="storeName"
  >
    <ValidationObserver ref="validator" v-slot="{}">
      <v-row justify="center">
        <v-col cols="6">
          <v-row>
            <v-col>
              <ValidationProvider
                ref="first_name"
                rules="required"
                v-slot="{ errors }"
              >
                <v-text-field
                  :error-messages="errors"
                  v-model="data.first_name"
                  label="Nombres"
                  prepend-inner-icon="fas fa-user"
                ></v-text-field>
              </ValidationProvider>
            </v-col>
            <v-col>
              <ValidationProvider
                ref="last_name"
                rules="required"
                v-slot="{ errors }"
              >
                <v-text-field
                  :error-messages="errors"
                  v-model="data.last_name"
                  label="Apellidos"
                  prepend-inner-icon="fas fa-user"
                ></v-text-field>
              </ValidationProvider>
            </v-col>
          </v-row>

          <v-row>
            <v-col>
              <ValidationProvider
                ref="email"
                rules="required|email"
                v-slot="{ errors }"
              >
                <v-text-field
                  :error-messages="errors"
                  v-model="data.email"
                  label="E-mail"
                  prepend-inner-icon="fas fa-envelope"
                ></v-text-field>
              </ValidationProvider>
            </v-col>
          </v-row>

          <v-row>
            <v-col>
              <ValidationProvider ref="phone" rules="" v-slot="{ errors }">
                <v-text-field
                  v-model="date_of_birth"
                  label="Fecha de Nacimiento"
                  prepend-icon="fas fa-calendar"
                  readonly
                ></v-text-field>
                <v-date-picker
                  :error-messages="errors"
                  v-model="date_of_birth"
                  no-title
                  scrollable
                >
                </v-date-picker>
              </ValidationProvider>
            </v-col>
          </v-row>

          <v-row>
            <v-col>
              <ValidationProvider ref="phone" rules="" v-slot="{ errors }">
                <v-text-field
                  :error-messages="errors"
                  v-model="data.phone"
                  label="Teléfono"
                  prepend-inner-icon="fas fa-mobile"
                ></v-text-field>
              </ValidationProvider>
            </v-col>
          </v-row>

          <v-row>
            <v-col>
              <ValidationProvider
                ref="country_id"
                rules="required"
                v-slot="{ errors }"
              >
                <v-select
                  :error-messages="errors"
                  v-model="data.country_id"
                  prepend-inner-icon="fas fa-map"
                  :items="countries"
                  item-text="name"
                  item-value="id"
                  label="País"
                ></v-select>
              </ValidationProvider>
            </v-col>
          </v-row>

          <v-row>
            <v-col>
              <ValidationProvider ref="dni" rules="" v-slot="{ errors }">
                <v-text-field
                  :error-messages="errors"
                  v-model="data.dni"
                  label="Documento/Pasaporte"
                  prepend-inner-icon="fas fa-id-card"
                ></v-text-field>
              </ValidationProvider>
            </v-col>
          </v-row>

          <v-row>
            <v-col>
              <ValidationProvider ref="curriculum" rules="" v-slot="{ errors }">
                <Upload
                  :error-messages="errors"
                  accept="application/pdf,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                  placeholder="Curriculum"
                  prepend-icon="fas fa-file"
                  label=""
                  :multiple="false"
                  :onSelectedPicture="onSelectedDocument"
                ></Upload>
                <a
                  :href="curriculum"
                  target="_blank"
                  v-if="curriculum && /(http(s?)):\/\//i.test(curriculum)"
                  ><i class="fas fa-download"></i>Descargar Currículum</a
                >
              </ValidationProvider>
            </v-col>
          </v-row>

          <!-- Agregar una nueva row que permita PREVISUALIZAR el CV -->
          <v-row v-if="curriculum">
            <v-col>
              <div v-if="isImage(curriculum)">
                <v-img
                  :src="curriculum"
                  alt="Previsualización del CV"
                  @click="showImageDialog = true"
                ></v-img>
              </div>
              <div v-else-if="isPDF(curriculum)">
                <iframe :src="curriculum" width="100%" height="500px"></iframe>
              </div>
              <div v-else>
                <p>El archivo seleccionado no se puede previsualizar.</p>
              </div>
            </v-col>
          </v-row>

          <v-dialog v-model="showImageDialog" max-width="90%">
            <v-card>
              <v-img :src="curriculum" alt="Previsualización del CV"></v-img>
            </v-card>
          </v-dialog>
        </v-col>
      </v-row>
    </ValidationObserver>
  </CrudForm>
</template>

<script>
import { ValidationObserver, ValidationProvider } from 'vee-validate';
import { mapState } from 'vuex';
import Upload from '@/components/Upload';
import CrudForm from '@/components/Crud/CrudForm';
import CrudFormMixin from '@/mixins/crud_form';

export default {
  mixins: [CrudFormMixin],
  components: { CrudForm, ValidationProvider, Upload, ValidationObserver },
  data() {
    return {
      storeName: 'Work_requests',
      title: 'Solicitud de trabajo',
      filteredAttributes: ['curriculum'],
      curriculum: '',
      menu_date: false,
      data: {
        first_name: '',
        last_name: '',
        email: '',
        phone: '',
        dni: '',
        dob: '',
        curriculum: '',
        country_id: '',
      },
    };
  },
  computed: {
    ...mapState({
      status: (state) => state.Work_requests.status,
      countries: (state) => state.Countries.list,
    }),
    date_of_birth: {
      // getter
      get: function() {
        return this.data.dob.substring(0, 10) || '';
      },
      // setter
      set: function(newValue) {
        this.data.dob = newValue;
      },
    },
  },
  created() {
    this.$store.dispatch('Countries/getListAll', {
      show_all: 'enable',
      sorting_column: 'name',
      sorting_order: 'asc',
    });
  },
  watch: {},
  methods: {
    onSelectedDocument(file) {
      const self = this;
      this.data.curriculum = file;

      let fr = new FileReader();
      fr.onload = function() {
        self.curriculum = fr.result;
      };
      fr.onerror = function() {
        self.curriculum = '';
      };
      fr.readAsDataURL(this.data.curriculum);
    },
    isImage(file) {
      return /\.(jpe?g|png|gif)$/i.test(file);
    },
    isPDF(file) {
      return /\.(pdf)$/i.test(file);
    },
  },
};
</script>
